import type { JSX } from 'preact'
import { InfoBigIcon } from '@/components/icons/InfoBigIcon'
import { Text } from '@/components'
import { getConfig } from '../../../config'
import { useTranslation } from 'react-i18next'

interface InfoBoxProps {
  title?: string
  description: string | JSX.Element
}

export function InfoBox({ title, description }: InfoBoxProps) {
  const { t } = useTranslation()
  const { serviceTermsUrl } = getConfig()

  return (
    <div className='bg-white border-3 border-primary-200 rounded-3xl p-5 sm:p-8'>
      <div className='flex items-center gap-4'>
        <div className='flex-shrink-0'>
          <InfoBigIcon className='w-8 h-8' />
        </div>
        <div className='flex-1'>
          {title && (
            <h3 className='mb-0.5 text-heading-4 font-semibold text-cencert-navy'>
              {title}
            </h3>
          )}
          <Text variant='small' color='text-gray'>
            {description}{' '}
            <a
              href={serviceTermsUrl ?? '#'}
              target='_blank'
              className='text-cencert-blue underline hover:no-underline'
            >
              {t('legalNotice.serviceTermsLink')}
            </a>
            .
          </Text>
        </div>
      </div>
    </div>
  )
}
